// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".account-details-switch[data-v-5de67418]{width:90px}.account-airbnb-pricing-adjustment-switch[data-v-5de67418]{width:150px}.form-tip[data-v-5de67418]{display:flex;align-items:center;height:40px;margin-bottom:1rem}@media(max-width: 799px){.save-button[data-v-5de67418]{width:100%}}", ""]);
// Exports
module.exports = exports;
